// extracted by mini-css-extract-plugin
export default {"container":"project-list-item-details_container__Kg71f","left":"project-list-item-details_left__y-TBQ","right":"project-list-item-details_right__QQKb2"};